
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/embed/trending-events",
      function () {
        return require("private-next-pages/embed/trending-events.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/embed/trending-events"])
      });
    }
  